var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#424242","fillRule":"evenodd","d":"M16.128 14.834L12 10.247l-4.128 4.587a.5.5 0 0 1-.744-.668l4.5-5a.5.5 0 0 1 .744 0l4.5 5a.5.5 0 1 1-.744.668z"}));
}

ChevronUp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
